import { render } from "./ProvinceTaskDetail.vue?vue&type=template&id=b756f5f8&scoped=true&ts=true"
import script from "./ProvinceTaskDetail.ts?vue&type=script&lang=ts"
export * from "./ProvinceTaskDetail.ts?vue&type=script&lang=ts"

import "./ProvinceTaskDetail.scss?vue&type=style&index=0&id=b756f5f8&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b756f5f8"]])

export default __exports__